module.exports = __webpack_public_path__ + "img/6.679548af.jpg";